/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Button } from '@msdyn365-commerce-modules/utilities';
import { IOrderTemplateNameDialogResources, OrderTemplateNameDialog } from '@msdyn365-commerce/components';
import { IComponentProps } from '@msdyn365-commerce/core';
import React, { useState } from 'react';

export interface ICreateOrderTemplateButtonProps extends IComponentProps {
    createOrderTemplateText: string;
    createOrderTemplateDialogResources: IOrderTemplateNameDialogResources;
    onOrderTemplateCreated(): Promise<void>;
}

const CreateOrderTemplateButton: React.FC<ICreateOrderTemplateButtonProps> = (props) => {
    const onCancel = () => {
        return;
    };
    const [createOrderTemplateDialogOpen, setOrderTemplateNameDialogOpen] = useState(false);
    const onCreateButtonClick = () => {
        setOrderTemplateNameDialogOpen(true);
    };

    return (
        <>
            <Button
                className='ms-order-template__add-template-button'
                color='primary'
                onClick={onCreateButtonClick}
            >
                {props.createOrderTemplateText}
            </Button>
            <OrderTemplateNameDialog
                className={'msc-order-template-name-dialog'}
                modalOpen={createOrderTemplateDialogOpen}
                isUpdateDialog={false}
                setModalOpen={setOrderTemplateNameDialogOpen}
                context={props.context}
                id={props.id}
                data={{}}
                typeName={props.typeName}
                dialogStrings={props.createOrderTemplateDialogResources}
                onCancel={onCancel}
                onSuccess={props.onOrderTemplateCreated}
            />
        </>
    );
};

export default CreateOrderTemplateButton;